// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/parser_analytics.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/parser_analytics.proto.
 */
export const file_v1_parser_analytics: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_api_annotations]);

/**
 * GetAllMessagesRequest pages through the unchecked messages of the last 30
 * days, newest first. Every filter is optional; an empty value matches all.
 *
 * @generated from message v1.GetAllMessagesRequest
 */
export type GetAllMessagesRequest = Message<"v1.GetAllMessagesRequest"> & {
  /**
   * Messages per page (default: 20, max: 100)
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * next_page_token of the previous page (empty for the first page)
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * errors | warnings | ambiguities | clean_success
   *
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * success | error
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * high (>=0.8) | medium (0.5-0.8) | low (<0.5); messages without ambiguity always match
   *
   * @generated from field: string confidence = 5;
   */
  confidence: string;

  /**
   * case-insensitive substring of the message or of an ambiguous value
   *
   * @generated from field: string search = 6;
   */
  search: string;

  /**
   * app | telegram
   *
   * @generated from field: string source = 7;
   */
  source: string;

  /**
   * fixed | pending | abandoned; only failed messages in an attempt group have one
   *
   * @generated from field: string fix_status = 8;
   */
  fixStatus: string;
};

/**
 * Describes the message v1.GetAllMessagesRequest.
 * Use `create(GetAllMessagesRequestSchema)` to create a new message.
 */
export const GetAllMessagesRequestSchema: GenMessage<GetAllMessagesRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 0);

/**
 * @generated from message v1.ParsedMessage
 */
export type ParsedMessage = Message<"v1.ParsedMessage"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string original_message = 2;
   */
  originalMessage: string;

  /**
   * Deprecated: no longer populated by GetAllMessages; the detail dialog
   * reads it from GetMessageAmbiguityDetails.
   *
   * @generated from field: string normalized_message = 3;
   */
  normalizedMessage: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: bool has_warnings = 5;
   */
  hasWarnings: boolean;

  /**
   * @generated from field: bool has_ambiguity = 6;
   */
  hasAmbiguity: boolean;

  /**
   * @generated from field: int32 total_errors = 7;
   */
  totalErrors: number;

  /**
   * @generated from field: int32 total_warnings = 8;
   */
  totalWarnings: number;

  /**
   * @generated from field: int32 total_bets = 9;
   */
  totalBets: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int32 ambiguity_count = 11;
   */
  ambiguityCount: number;

  /**
   * @generated from field: double lowest_confidence = 12;
   */
  lowestConfidence: number;

  /**
   * @generated from field: string ambiguous_values = 13;
   */
  ambiguousValues: string;

  /**
   * app | telegram
   *
   * @generated from field: string source = 14;
   */
  source: string;

  /**
   * "" | fixed | pending | abandoned (failed rows in an attempt group only)
   *
   * @generated from field: string fix_status = 15;
   */
  fixStatus: string;
};

/**
 * Describes the message v1.ParsedMessage.
 * Use `create(ParsedMessageSchema)` to create a new message.
 */
export const ParsedMessageSchema: GenMessage<ParsedMessage> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 1);

/**
 * @generated from message v1.GetAllMessagesResponse
 */
export type GetAllMessagesResponse = Message<"v1.GetAllMessagesResponse"> & {
  /**
   * @generated from field: repeated v1.ParsedMessage messages = 1;
   */
  messages: ParsedMessage[];

  /**
   * Token for the next page (empty if no more pages)
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Messages matching the filters; set only on the first page (empty page_token)
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message v1.GetAllMessagesResponse.
 * Use `create(GetAllMessagesResponseSchema)` to create a new message.
 */
export const GetAllMessagesResponseSchema: GenMessage<GetAllMessagesResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 2);

/**
 * @generated from message v1.GetMessagesWithAmbiguitiesRequest
 */
export type GetMessagesWithAmbiguitiesRequest = Message<"v1.GetMessagesWithAmbiguitiesRequest"> & {
};

/**
 * Describes the message v1.GetMessagesWithAmbiguitiesRequest.
 * Use `create(GetMessagesWithAmbiguitiesRequestSchema)` to create a new message.
 */
export const GetMessagesWithAmbiguitiesRequestSchema: GenMessage<GetMessagesWithAmbiguitiesRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 3);

/**
 * @generated from message v1.MessageWithAmbiguities
 */
export type MessageWithAmbiguities = Message<"v1.MessageWithAmbiguities"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string original_message = 2;
   */
  originalMessage: string;

  /**
   * @generated from field: string normalized_message = 3;
   */
  normalizedMessage: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: bool has_warnings = 5;
   */
  hasWarnings: boolean;

  /**
   * @generated from field: bool has_ambiguity = 6;
   */
  hasAmbiguity: boolean;

  /**
   * @generated from field: int32 total_errors = 7;
   */
  totalErrors: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int32 ambiguity_count = 9;
   */
  ambiguityCount: number;

  /**
   * @generated from field: double lowest_confidence = 10;
   */
  lowestConfidence: number;

  /**
   * @generated from field: string ambiguous_values = 11;
   */
  ambiguousValues: string;
};

/**
 * Describes the message v1.MessageWithAmbiguities.
 * Use `create(MessageWithAmbiguitiesSchema)` to create a new message.
 */
export const MessageWithAmbiguitiesSchema: GenMessage<MessageWithAmbiguities> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 4);

/**
 * @generated from message v1.GetMessagesWithAmbiguitiesResponse
 */
export type GetMessagesWithAmbiguitiesResponse = Message<"v1.GetMessagesWithAmbiguitiesResponse"> & {
  /**
   * @generated from field: repeated v1.MessageWithAmbiguities messages = 1;
   */
  messages: MessageWithAmbiguities[];
};

/**
 * Describes the message v1.GetMessagesWithAmbiguitiesResponse.
 * Use `create(GetMessagesWithAmbiguitiesResponseSchema)` to create a new message.
 */
export const GetMessagesWithAmbiguitiesResponseSchema: GenMessage<GetMessagesWithAmbiguitiesResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 5);

/**
 * @generated from message v1.GetMessageAmbiguityDetailsRequest
 */
export type GetMessageAmbiguityDetailsRequest = Message<"v1.GetMessageAmbiguityDetailsRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.GetMessageAmbiguityDetailsRequest.
 * Use `create(GetMessageAmbiguityDetailsRequestSchema)` to create a new message.
 */
export const GetMessageAmbiguityDetailsRequestSchema: GenMessage<GetMessageAmbiguityDetailsRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 6);

/**
 * @generated from message v1.MessageDetails
 */
export type MessageDetails = Message<"v1.MessageDetails"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string original_message = 2;
   */
  originalMessage: string;

  /**
   * @generated from field: string normalized_message = 3;
   */
  normalizedMessage: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: bool has_warnings = 5;
   */
  hasWarnings: boolean;

  /**
   * @generated from field: bool has_ambiguity = 6;
   */
  hasAmbiguity: boolean;

  /**
   * @generated from field: int32 total_errors = 7;
   */
  totalErrors: number;

  /**
   * @generated from field: int32 total_warnings = 8;
   */
  totalWarnings: number;

  /**
   * @generated from field: int32 total_bets = 9;
   */
  totalBets: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * JSON string containing user preferences at parse time
   *
   * @generated from field: string user_context = 11;
   */
  userContext: string;

  /**
   * Mark as reviewed/checked
   *
   * @generated from field: bool checked = 12;
   */
  checked: boolean;
};

/**
 * Describes the message v1.MessageDetails.
 * Use `create(MessageDetailsSchema)` to create a new message.
 */
export const MessageDetailsSchema: GenMessage<MessageDetails> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 7);

/**
 * @generated from message v1.Ambiguity
 */
export type Ambiguity = Message<"v1.Ambiguity"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 analytics_id = 2;
   */
  analyticsId: number;

  /**
   * @generated from field: string ambiguous_value = 3;
   */
  ambiguousValue: string;

  /**
   * @generated from field: int32 token_position = 4;
   */
  tokenPosition: number;

  /**
   * @generated from field: string resolved_as = 5;
   */
  resolvedAs: string;

  /**
   * @generated from field: int32 resolution_strategy = 6;
   */
  resolutionStrategy: number;

  /**
   * @generated from field: double confidence_score = 7;
   */
  confidenceScore: number;

  /**
   * @generated from field: string warning_message = 8;
   */
  warningMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message v1.Ambiguity.
 * Use `create(AmbiguitySchema)` to create a new message.
 */
export const AmbiguitySchema: GenMessage<Ambiguity> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 8);

/**
 * @generated from message v1.ParserErrorDetail
 */
export type ParserErrorDetail = Message<"v1.ParserErrorDetail"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 analytics_id = 2;
   */
  analyticsId: number;

  /**
   * @generated from field: string error_code = 3;
   */
  errorCode: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage: string;

  /**
   * @generated from field: int32 error_column = 5;
   */
  errorColumn: number;

  /**
   * @generated from field: int32 error_end_column = 6;
   */
  errorEndColumn: number;

  /**
   * @generated from field: string error_stage = 7;
   */
  errorStage: string;

  /**
   * @generated from field: int32 error_index = 8;
   */
  errorIndex: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message v1.ParserErrorDetail.
 * Use `create(ParserErrorDetailSchema)` to create a new message.
 */
export const ParserErrorDetailSchema: GenMessage<ParserErrorDetail> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 9);

/**
 * @generated from message v1.ParserWarningDetail
 */
export type ParserWarningDetail = Message<"v1.ParserWarningDetail"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 analytics_id = 2;
   */
  analyticsId: number;

  /**
   * @generated from field: string warning_type = 3;
   */
  warningType: string;

  /**
   * @generated from field: string warning_message = 4;
   */
  warningMessage: string;

  /**
   * @generated from field: int32 bet_index = 5;
   */
  betIndex: number;

  /**
   * @generated from field: string original_value = 6;
   */
  originalValue: string;

  /**
   * @generated from field: string transformed_value = 7;
   */
  transformedValue: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message v1.ParserWarningDetail.
 * Use `create(ParserWarningDetailSchema)` to create a new message.
 */
export const ParserWarningDetailSchema: GenMessage<ParserWarningDetail> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 10);

/**
 * @generated from message v1.GetMessageAmbiguityDetailsResponse
 */
export type GetMessageAmbiguityDetailsResponse = Message<"v1.GetMessageAmbiguityDetailsResponse"> & {
  /**
   * @generated from field: v1.MessageDetails message = 1;
   */
  message?: MessageDetails;

  /**
   * @generated from field: repeated v1.Ambiguity ambiguities = 2;
   */
  ambiguities: Ambiguity[];

  /**
   * @generated from field: repeated v1.ParserErrorDetail errors = 3;
   */
  errors: ParserErrorDetail[];

  /**
   * @generated from field: repeated v1.ParserWarningDetail warnings = 4;
   */
  warnings: ParserWarningDetail[];
};

/**
 * Describes the message v1.GetMessageAmbiguityDetailsResponse.
 * Use `create(GetMessageAmbiguityDetailsResponseSchema)` to create a new message.
 */
export const GetMessageAmbiguityDetailsResponseSchema: GenMessage<GetMessageAmbiguityDetailsResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 11);

/**
 * @generated from message v1.GetTopParserErrorsRequest
 */
export type GetTopParserErrorsRequest = Message<"v1.GetTopParserErrorsRequest"> & {
};

/**
 * Describes the message v1.GetTopParserErrorsRequest.
 * Use `create(GetTopParserErrorsRequestSchema)` to create a new message.
 */
export const GetTopParserErrorsRequestSchema: GenMessage<GetTopParserErrorsRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 12);

/**
 * @generated from message v1.ParserErrorStat
 */
export type ParserErrorStat = Message<"v1.ParserErrorStat"> & {
  /**
   * @generated from field: string error_code = 1;
   */
  errorCode: string;

  /**
   * @generated from field: string error_stage = 2;
   */
  errorStage: string;

  /**
   * @generated from field: int64 error_count = 3;
   */
  errorCount: bigint;

  /**
   * @generated from field: int64 affected_messages = 4;
   */
  affectedMessages: bigint;
};

/**
 * Describes the message v1.ParserErrorStat.
 * Use `create(ParserErrorStatSchema)` to create a new message.
 */
export const ParserErrorStatSchema: GenMessage<ParserErrorStat> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 13);

/**
 * @generated from message v1.GetTopParserErrorsResponse
 */
export type GetTopParserErrorsResponse = Message<"v1.GetTopParserErrorsResponse"> & {
  /**
   * @generated from field: repeated v1.ParserErrorStat errors = 1;
   */
  errors: ParserErrorStat[];
};

/**
 * Describes the message v1.GetTopParserErrorsResponse.
 * Use `create(GetTopParserErrorsResponseSchema)` to create a new message.
 */
export const GetTopParserErrorsResponseSchema: GenMessage<GetTopParserErrorsResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 14);

/**
 * @generated from message v1.GetAmbiguityStatsRequest
 */
export type GetAmbiguityStatsRequest = Message<"v1.GetAmbiguityStatsRequest"> & {
};

/**
 * Describes the message v1.GetAmbiguityStatsRequest.
 * Use `create(GetAmbiguityStatsRequestSchema)` to create a new message.
 */
export const GetAmbiguityStatsRequestSchema: GenMessage<GetAmbiguityStatsRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 15);

/**
 * @generated from message v1.AmbiguityStat
 */
export type AmbiguityStat = Message<"v1.AmbiguityStat"> & {
  /**
   * @generated from field: string ambiguous_value = 1;
   */
  ambiguousValue: string;

  /**
   * @generated from field: int64 total_occurrences = 2;
   */
  totalOccurrences: bigint;

  /**
   * @generated from field: int64 resolved_as_station = 3;
   */
  resolvedAsStation: bigint;

  /**
   * @generated from field: int64 resolved_as_bet_type = 4;
   */
  resolvedAsBetType: bigint;

  /**
   * @generated from field: int64 unresolved_count = 5;
   */
  unresolvedCount: bigint;

  /**
   * @generated from field: double avg_confidence = 6;
   */
  avgConfidence: number;

  /**
   * @generated from field: double min_confidence = 7;
   */
  minConfidence: number;

  /**
   * @generated from field: double max_confidence = 8;
   */
  maxConfidence: number;
};

/**
 * Describes the message v1.AmbiguityStat.
 * Use `create(AmbiguityStatSchema)` to create a new message.
 */
export const AmbiguityStatSchema: GenMessage<AmbiguityStat> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 16);

/**
 * @generated from message v1.GetAmbiguityStatsResponse
 */
export type GetAmbiguityStatsResponse = Message<"v1.GetAmbiguityStatsResponse"> & {
  /**
   * @generated from field: repeated v1.AmbiguityStat stats = 1;
   */
  stats: AmbiguityStat[];
};

/**
 * Describes the message v1.GetAmbiguityStatsResponse.
 * Use `create(GetAmbiguityStatsResponseSchema)` to create a new message.
 */
export const GetAmbiguityStatsResponseSchema: GenMessage<GetAmbiguityStatsResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 17);

/**
 * @generated from message v1.GetParseSuccessRateTrendRequest
 */
export type GetParseSuccessRateTrendRequest = Message<"v1.GetParseSuccessRateTrendRequest"> & {
};

/**
 * Describes the message v1.GetParseSuccessRateTrendRequest.
 * Use `create(GetParseSuccessRateTrendRequestSchema)` to create a new message.
 */
export const GetParseSuccessRateTrendRequestSchema: GenMessage<GetParseSuccessRateTrendRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 18);

/**
 * @generated from message v1.ParseSuccessRateTrend
 */
export type ParseSuccessRateTrend = Message<"v1.ParseSuccessRateTrend"> & {
  /**
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * @generated from field: int64 total_parses = 2;
   */
  totalParses: bigint;

  /**
   * @generated from field: int64 successful_parses = 3;
   */
  successfulParses: bigint;

  /**
   * @generated from field: double success_rate = 4;
   */
  successRate: number;
};

/**
 * Describes the message v1.ParseSuccessRateTrend.
 * Use `create(ParseSuccessRateTrendSchema)` to create a new message.
 */
export const ParseSuccessRateTrendSchema: GenMessage<ParseSuccessRateTrend> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 19);

/**
 * @generated from message v1.GetParseSuccessRateTrendResponse
 */
export type GetParseSuccessRateTrendResponse = Message<"v1.GetParseSuccessRateTrendResponse"> & {
  /**
   * @generated from field: repeated v1.ParseSuccessRateTrend trend = 1;
   */
  trend: ParseSuccessRateTrend[];
};

/**
 * Describes the message v1.GetParseSuccessRateTrendResponse.
 * Use `create(GetParseSuccessRateTrendResponseSchema)` to create a new message.
 */
export const GetParseSuccessRateTrendResponseSchema: GenMessage<GetParseSuccessRateTrendResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 20);

/**
 * @generated from message v1.GetSuccessWithWarningsStatsRequest
 */
export type GetSuccessWithWarningsStatsRequest = Message<"v1.GetSuccessWithWarningsStatsRequest"> & {
};

/**
 * Describes the message v1.GetSuccessWithWarningsStatsRequest.
 * Use `create(GetSuccessWithWarningsStatsRequestSchema)` to create a new message.
 */
export const GetSuccessWithWarningsStatsRequestSchema: GenMessage<GetSuccessWithWarningsStatsRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 21);

/**
 * @generated from message v1.SuccessWithWarningsStats
 */
export type SuccessWithWarningsStats = Message<"v1.SuccessWithWarningsStats"> & {
  /**
   * @generated from field: int64 total_success = 1;
   */
  totalSuccess: bigint;

  /**
   * @generated from field: int64 success_with_warnings = 2;
   */
  successWithWarnings: bigint;

  /**
   * @generated from field: int64 clean_success = 3;
   */
  cleanSuccess: bigint;

  /**
   * @generated from field: double warning_percentage = 4;
   */
  warningPercentage: number;
};

/**
 * Describes the message v1.SuccessWithWarningsStats.
 * Use `create(SuccessWithWarningsStatsSchema)` to create a new message.
 */
export const SuccessWithWarningsStatsSchema: GenMessage<SuccessWithWarningsStats> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 22);

/**
 * @generated from message v1.GetSuccessWithWarningsStatsResponse
 */
export type GetSuccessWithWarningsStatsResponse = Message<"v1.GetSuccessWithWarningsStatsResponse"> & {
  /**
   * @generated from field: v1.SuccessWithWarningsStats stats = 1;
   */
  stats?: SuccessWithWarningsStats;
};

/**
 * Describes the message v1.GetSuccessWithWarningsStatsResponse.
 * Use `create(GetSuccessWithWarningsStatsResponseSchema)` to create a new message.
 */
export const GetSuccessWithWarningsStatsResponseSchema: GenMessage<GetSuccessWithWarningsStatsResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 23);

/**
 * @generated from message v1.GetTopWarningTypesRequest
 */
export type GetTopWarningTypesRequest = Message<"v1.GetTopWarningTypesRequest"> & {
};

/**
 * Describes the message v1.GetTopWarningTypesRequest.
 * Use `create(GetTopWarningTypesRequestSchema)` to create a new message.
 */
export const GetTopWarningTypesRequestSchema: GenMessage<GetTopWarningTypesRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 24);

/**
 * @generated from message v1.WarningType
 */
export type WarningType = Message<"v1.WarningType"> & {
  /**
   * @generated from field: string warning_type = 1;
   */
  warningType: string;

  /**
   * @generated from field: int64 occurrence_count = 2;
   */
  occurrenceCount: bigint;

  /**
   * @generated from field: int64 affected_messages = 3;
   */
  affectedMessages: bigint;
};

/**
 * Describes the message v1.WarningType.
 * Use `create(WarningTypeSchema)` to create a new message.
 */
export const WarningTypeSchema: GenMessage<WarningType> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 25);

/**
 * @generated from message v1.GetTopWarningTypesResponse
 */
export type GetTopWarningTypesResponse = Message<"v1.GetTopWarningTypesResponse"> & {
  /**
   * @generated from field: repeated v1.WarningType warnings = 1;
   */
  warnings: WarningType[];
};

/**
 * Describes the message v1.GetTopWarningTypesResponse.
 * Use `create(GetTopWarningTypesResponseSchema)` to create a new message.
 */
export const GetTopWarningTypesResponseSchema: GenMessage<GetTopWarningTypesResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 26);

/**
 * @generated from message v1.GetResolutionStrategyStatsRequest
 */
export type GetResolutionStrategyStatsRequest = Message<"v1.GetResolutionStrategyStatsRequest"> & {
};

/**
 * Describes the message v1.GetResolutionStrategyStatsRequest.
 * Use `create(GetResolutionStrategyStatsRequestSchema)` to create a new message.
 */
export const GetResolutionStrategyStatsRequestSchema: GenMessage<GetResolutionStrategyStatsRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 27);

/**
 * @generated from message v1.ResolutionStrategyStat
 */
export type ResolutionStrategyStat = Message<"v1.ResolutionStrategyStat"> & {
  /**
   * @generated from field: int32 resolution_strategy = 1;
   */
  resolutionStrategy: number;

  /**
   * @generated from field: int64 usage_count = 2;
   */
  usageCount: bigint;

  /**
   * @generated from field: int64 success_count = 3;
   */
  successCount: bigint;

  /**
   * @generated from field: double avg_confidence = 4;
   */
  avgConfidence: number;

  /**
   * @generated from field: double success_rate = 5;
   */
  successRate: number;
};

/**
 * Describes the message v1.ResolutionStrategyStat.
 * Use `create(ResolutionStrategyStatSchema)` to create a new message.
 */
export const ResolutionStrategyStatSchema: GenMessage<ResolutionStrategyStat> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 28);

/**
 * @generated from message v1.GetResolutionStrategyStatsResponse
 */
export type GetResolutionStrategyStatsResponse = Message<"v1.GetResolutionStrategyStatsResponse"> & {
  /**
   * @generated from field: repeated v1.ResolutionStrategyStat stats = 1;
   */
  stats: ResolutionStrategyStat[];
};

/**
 * Describes the message v1.GetResolutionStrategyStatsResponse.
 * Use `create(GetResolutionStrategyStatsResponseSchema)` to create a new message.
 */
export const GetResolutionStrategyStatsResponseSchema: GenMessage<GetResolutionStrategyStatsResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 29);

/**
 * @generated from message v1.GetTransformationUsageRequest
 */
export type GetTransformationUsageRequest = Message<"v1.GetTransformationUsageRequest"> & {
};

/**
 * Describes the message v1.GetTransformationUsageRequest.
 * Use `create(GetTransformationUsageRequestSchema)` to create a new message.
 */
export const GetTransformationUsageRequestSchema: GenMessage<GetTransformationUsageRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 30);

/**
 * @generated from message v1.TransformationUsage
 */
export type TransformationUsage = Message<"v1.TransformationUsage"> & {
  /**
   * @generated from field: string transform_type = 1;
   */
  transformType: string;

  /**
   * @generated from field: string required_permission = 2;
   */
  requiredPermission: string;

  /**
   * @generated from field: int64 usage_count = 3;
   */
  usageCount: bigint;

  /**
   * @generated from field: int64 enabled_count = 4;
   */
  enabledCount: bigint;

  /**
   * @generated from field: double enabled_percentage = 5;
   */
  enabledPercentage: number;
};

/**
 * Describes the message v1.TransformationUsage.
 * Use `create(TransformationUsageSchema)` to create a new message.
 */
export const TransformationUsageSchema: GenMessage<TransformationUsage> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 31);

/**
 * @generated from message v1.GetTransformationUsageResponse
 */
export type GetTransformationUsageResponse = Message<"v1.GetTransformationUsageResponse"> & {
  /**
   * @generated from field: repeated v1.TransformationUsage usage = 1;
   */
  usage: TransformationUsage[];
};

/**
 * Describes the message v1.GetTransformationUsageResponse.
 * Use `create(GetTransformationUsageResponseSchema)` to create a new message.
 */
export const GetTransformationUsageResponseSchema: GenMessage<GetTransformationUsageResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 32);

/**
 * @generated from message v1.ToggleCheckedRequest
 */
export type ToggleCheckedRequest = Message<"v1.ToggleCheckedRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.ToggleCheckedRequest.
 * Use `create(ToggleCheckedRequestSchema)` to create a new message.
 */
export const ToggleCheckedRequestSchema: GenMessage<ToggleCheckedRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 33);

/**
 * @generated from message v1.ToggleCheckedResponse
 */
export type ToggleCheckedResponse = Message<"v1.ToggleCheckedResponse"> & {
  /**
   * New checked status after toggle
   *
   * @generated from field: bool checked = 1;
   */
  checked: boolean;
};

/**
 * Describes the message v1.ToggleCheckedResponse.
 * Use `create(ToggleCheckedResponseSchema)` to create a new message.
 */
export const ToggleCheckedResponseSchema: GenMessage<ToggleCheckedResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 34);

/**
 * @generated from message v1.GetAttemptGroupRequest
 */
export type GetAttemptGroupRequest = Message<"v1.GetAttemptGroupRequest"> & {
  /**
   * @generated from field: int32 analytics_id = 1;
   */
  analyticsId: number;
};

/**
 * Describes the message v1.GetAttemptGroupRequest.
 * Use `create(GetAttemptGroupRequestSchema)` to create a new message.
 */
export const GetAttemptGroupRequestSchema: GenMessage<GetAttemptGroupRequest> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 35);

/**
 * AttemptGroupItem is one parse attempt of a message, with its first error.
 *
 * @generated from message v1.AttemptGroupItem
 */
export type AttemptGroupItem = Message<"v1.AttemptGroupItem"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string original_message = 2;
   */
  originalMessage: string;

  /**
   * success | error
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * first error's code; empty on success
   *
   * @generated from field: string error_code = 4;
   */
  errorCode: string;

  /**
   * first error's Vietnamese message; empty on success
   *
   * @generated from field: string error_message = 5;
   */
  errorMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message v1.AttemptGroupItem.
 * Use `create(AttemptGroupItemSchema)` to create a new message.
 */
export const AttemptGroupItemSchema: GenMessage<AttemptGroupItem> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 36);

/**
 * @generated from message v1.GetAttemptGroupResponse
 */
export type GetAttemptGroupResponse = Message<"v1.GetAttemptGroupResponse"> & {
  /**
   * oldest first; empty when the message has no group
   *
   * @generated from field: repeated v1.AttemptGroupItem items = 1;
   */
  items: AttemptGroupItem[];
};

/**
 * Describes the message v1.GetAttemptGroupResponse.
 * Use `create(GetAttemptGroupResponseSchema)` to create a new message.
 */
export const GetAttemptGroupResponseSchema: GenMessage<GetAttemptGroupResponse> = /*@__PURE__*/
  messageDesc(file_v1_parser_analytics, 37);

/**
 * @generated from service v1.ParserAnalyticsService
 */
export const ParserAnalyticsService: GenService<{
  /**
   * Get all parsed messages (all types: success, error, warnings, ambiguities)
   *
   * @generated from rpc v1.ParserAnalyticsService.GetAllMessages
   */
  getAllMessages: {
    methodKind: "unary";
    input: typeof GetAllMessagesRequestSchema;
    output: typeof GetAllMessagesResponseSchema;
  },
  /**
   * Get all messages with ambiguous tokens
   *
   * @generated from rpc v1.ParserAnalyticsService.GetMessagesWithAmbiguities
   */
  getMessagesWithAmbiguities: {
    methodKind: "unary";
    input: typeof GetMessagesWithAmbiguitiesRequestSchema;
    output: typeof GetMessagesWithAmbiguitiesResponseSchema;
  },
  /**
   * Get detailed information about a specific message's ambiguities
   *
   * @generated from rpc v1.ParserAnalyticsService.GetMessageAmbiguityDetails
   */
  getMessageAmbiguityDetails: {
    methodKind: "unary";
    input: typeof GetMessageAmbiguityDetailsRequestSchema;
    output: typeof GetMessageAmbiguityDetailsResponseSchema;
  },
  /**
   * Get top parser errors (last 30 days)
   *
   * @generated from rpc v1.ParserAnalyticsService.GetTopParserErrors
   */
  getTopParserErrors: {
    methodKind: "unary";
    input: typeof GetTopParserErrorsRequestSchema;
    output: typeof GetTopParserErrorsResponseSchema;
  },
  /**
   * Get ambiguity resolution statistics
   *
   * @generated from rpc v1.ParserAnalyticsService.GetAmbiguityStats
   */
  getAmbiguityStats: {
    methodKind: "unary";
    input: typeof GetAmbiguityStatsRequestSchema;
    output: typeof GetAmbiguityStatsResponseSchema;
  },
  /**
   * Get parse success rate trend over time
   *
   * @generated from rpc v1.ParserAnalyticsService.GetParseSuccessRateTrend
   */
  getParseSuccessRateTrend: {
    methodKind: "unary";
    input: typeof GetParseSuccessRateTrendRequestSchema;
    output: typeof GetParseSuccessRateTrendResponseSchema;
  },
  /**
   * Get statistics about successful parses with warnings
   *
   * @generated from rpc v1.ParserAnalyticsService.GetSuccessWithWarningsStats
   */
  getSuccessWithWarningsStats: {
    methodKind: "unary";
    input: typeof GetSuccessWithWarningsStatsRequestSchema;
    output: typeof GetSuccessWithWarningsStatsResponseSchema;
  },
  /**
   * Get top warning types
   *
   * @generated from rpc v1.ParserAnalyticsService.GetTopWarningTypes
   */
  getTopWarningTypes: {
    methodKind: "unary";
    input: typeof GetTopWarningTypesRequestSchema;
    output: typeof GetTopWarningTypesResponseSchema;
  },
  /**
   * Get resolution strategy effectiveness statistics
   *
   * @generated from rpc v1.ParserAnalyticsService.GetResolutionStrategyStats
   */
  getResolutionStrategyStats: {
    methodKind: "unary";
    input: typeof GetResolutionStrategyStatsRequestSchema;
    output: typeof GetResolutionStrategyStatsResponseSchema;
  },
  /**
   * Get transformation usage statistics
   *
   * @generated from rpc v1.ParserAnalyticsService.GetTransformationUsage
   */
  getTransformationUsage: {
    methodKind: "unary";
    input: typeof GetTransformationUsageRequestSchema;
    output: typeof GetTransformationUsageResponseSchema;
  },
  /**
   * Toggle checked status for a parser analytics record
   *
   * @generated from rpc v1.ParserAnalyticsService.ToggleChecked
   */
  toggleChecked: {
    methodKind: "unary";
    input: typeof ToggleCheckedRequestSchema;
    output: typeof ToggleCheckedResponseSchema;
  },
  /**
   * Get every parse attempt in the same attempt group as one message (admin only)
   *
   * @generated from rpc v1.ParserAnalyticsService.GetAttemptGroup
   */
  getAttemptGroup: {
    methodKind: "unary";
    input: typeof GetAttemptGroupRequestSchema;
    output: typeof GetAttemptGroupResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_parser_analytics, 0);

